<template>
  <form @submit.prevent="handleSubmit">
    <b-row>
      <ModalAttacment
        :isOpen="showModal"
        @close="showModal = false"
        :attachments="selectedItem?.filePreview"
      />
      <b-sidebar
        v-model="showSidebar"
        right
        width="70%"
        bg-variant="white"
        :title="titleSidebar"
        @hide="selectedItem = null"
        shadow
        backdrop
      >
        <template v-if="showSidebar">
          <div
            v-if="
              titleSidebar == 'Add Service & Repair' ||
              titleSidebar == 'Update Service & Repair'
            "
          >
            <FormItemSR
              :loading="loading.post"
              @onUpdateSr="handleUpdateJobs"
              :multipleSelected="multipleSelected"
              :headerForm="headerForm"
              :optionsTaskType="optionsTaskType"
              :optionsDepartment="optionsDepartment"
              :optionsCategory="optionsCategory"
              :optionsClassification="optionsClassification"
              :optionsCause="optionsCause"
              :optionsKindTask="optionsKindTask"
              @close="showSidebar = false"
              @save="handleSaveItem"
              @refetch="handleRefetch"
              :selectedItem="selectedItem"
              :formId="formId"
              :fleetSelected="fleetSelected"
            />
          </div>
          <div
            v-if="
              titleSidebar == 'Progress Item Repair' ||
              titleSidebar == 'Detail Item Service & Repair'
            "
          >
            <DailyProgress
              @refetch="() => getSingleServiceAndRepair(formId)"
              :readonly="titleSidebar == 'Detail Item Service & Repair'"
              :selectedItem="selectedItem"
              :optionsTaskType="optionsTaskType"
              :optionsDepartment="optionsDepartment"
              :optionsCategory="optionsCategory"
              :optionsClassification="optionsClassification"
              :optionsCause="optionsCause"
              :optionsKindTask="optionsKindTask"
              :formId="formId"
              :defaultParams="defaultParams"
            />
          </div>
          <div v-if="titleSidebar == 'Review Item Service & Repair'">
            <FormReviewSR
              :multipleSelected="multipleSelected"
              @refetch="handleRefetch"
              :selectedItem="selectedItem"
              :optionsTaskType="optionsTaskType"
              :optionsDepartment="optionsDepartment"
              :optionsCategory="optionsCategory"
              :optionsClassification="optionsClassification"
              :optionsCause="optionsCause"
              :optionsKindTask="optionsKindTask"
              :formId="formId"
            />
          </div>
          <div v-if="titleSidebar == 'Approve Item Service & Repair'">
            <FormApproveSR
              :multipleSelected="multipleSelected"
              @refetch="handleRefetch"
              :selectedItem="selectedItem"
              :optionsTaskType="optionsTaskType"
              :optionsDepartment="optionsDepartment"
              :optionsCategory="optionsCategory"
              :optionsClassification="optionsClassification"
              :optionsCause="optionsCause"
              :optionsKindTask="optionsKindTask"
              :formId="formId"
            />
          </div>
        </template>
      </b-sidebar>
      <b-col lg="6">
        <div v-if="!$route.query?.finish" class="d-flex align-items-center">
          <i
            class="fa fa-undo mr-4 cursor-pointer"
            @click="$router.push('/sr/service-repair-list')"
          ></i>
          <i
            class="fa fa-refresh mr-4 cursor-pointer"
            @click="handleRefetch"
          ></i>
          <template v-if="headerForm?.status != 'finish'">
            <i class="fa fa-plus mr-4 cursor-pointer" @click="onClickAdd"></i>
            <i
              v-if="getPermissionSR('update')"
              class="fa fa-edit mr-4 cursor-pointer"
              @click="handleEditMulti"
            ></i>
            <i
              v-if="getPermissionSR('delete')"
              class="fa fa-trash cursor-pointer"
              @click="
                () =>
                  $route.query?.formId
                    ? handleDeleteJobs()
                    : deleteItemBeforeCreate()
              "
            ></i>
          </template>
          <div
            class="d-flex align-items-center ml-5"
            v-if="$route.query?.detail && headerForm?.status != 'finish'"
          >
            <b-button
              type="button"
              v-if="showReview && getPermissionSR('review')"
              class="px-3 mr-2"
              variant="info"
              size="sm"
              @click="onReviewBulk"
              >Review</b-button
            >
            <b-button
              type="button"
              :disabled="!listItems.some((el) => el?.status?.name == 'Review')"
              class="px-3"
              variant="primary"
              size="sm"
              @click="onApproveBulk"
              v-if="showApprove && getPermissionSR('approval')"
              >Approve</b-button
            >
          </div>
        </div>
      </b-col>
      <b-col lg="6" class="d-flex justify-content-end">
        <form @submit.prevent class="w-100 d-flex justify-content-end">
          <b-form-input
            class="w-50 bg-white"
            placeholder="Search..."
            v-model="filterByName"
          />
        </form>
      </b-col>
      <b-col lg="12" class="mt-3">
        <!-- {{listItems?.filter((el) => el?.status?.name == 'New')}} -->
        <div class="overflow-auto relative w-100">
          <table class="w-100">
            <thead>
              <th class="sticky col-1" v-if="!$route.query?.finish">
                <input
                  type="checkbox"
                  id="checkal"
                  name="checkal"
                  :disabled="headerForm.status == 'finish'"
                  style="width: 16px; height: 16px"
                  :checked="isChckedAll"
                  @change="
                    (e) => {
                      checkedAll = e.target.checked
                      handleCheckAll()
                    }
                  "
                />
              </th>
              <th
                class="sticky"
                :class="{
                  'col-2': !$route.query?.finish,
                  'col-2-finish': $route.query?.finish,
                }"
              >
                Action
              </th>
              <th
                class="text-nowrap sticky"
                :class="{
                  'col-3': !$route.query?.finish,
                  'col-3-finish': $route.query?.finish,
                }"
              >
                Equipment Name
              </th>
              <th class="text-nowrap">Attachment</th>
              <th class="text-nowrap">Est. Cost Per Task</th>
              <th
                class="text-nowrap"
                v-if="$route.query?.finish || headerForm?.cost_real"
                >Real Cost Per Item *</th
              >
              <th
                class="text-nowrap"
                v-if="$route.query?.finish || headerForm?.cost_real"
                >Done By</th
              >
              <th class="text-nowrap" v-if="$route.query?.detail || formId"
                >Status Item</th
              >
              <th class="text-nowrap">Work Item</th>
              <th class="text-nowrap">Est. Start Date</th>
              <th class="text-nowrap">Est. Finish Date</th>
              <th class="text-nowrap">Type Repair</th>
              <th class="text-nowrap">Repair Section</th>
              <th class="text-nowrap">Category</th>
              <th class="text-nowrap">Classification</th>
              <th class="text-nowrap">Cause</th>
              <th class="text-nowrap">Kind Of Task</th>
              <th class="text-nowrap">Item Remarks</th>
            </thead>
            <tbody>
              <template v-if="!loading.fetch">
                <tr
                  class="bg-white"
                  v-for="(item, index) in listItems"
                  :key="index"
                >
                  <template v-if="isVisible(item)">
                    <td
                      class="sticky col-1 bg-white"
                      v-if="!$route.query?.finish"
                    >
                      <input
                        class="pr-0"
                        type="checkbox"
                        style="width: 16px; height: 16px"
                        v-model="item.checked"
                        :disabled="
                          ['Progress', 'Finish'].includes(item?.status?.name)
                        "
                      />
                    </td>
                    <td
                      class="sticky bg-white"
                      :class="{
                        'col-2': !$route.query?.finish,
                        'col-2-finish': $route.query?.finish,
                      }"
                    >
                      <b-button
                        type="button"
                        :id="`popover-target-${index}`"
                        variant="outline-primary"
                        class="d-flex align-items-center"
                        size="sm"
                        >Action <i class="fa fa-caret-down ml-2"></i
                      ></b-button>
                      <b-popover
                        :target="`popover-target-${index}`"
                        triggers="focus"
                        placement="bottom"
                        custom-class="p-0"
                      >
                        <div
                          v-if="
                            item?.status?.name === 'Review' &&
                            getPermissionSR('approval')
                          "
                          class="p-1 px-3 action-item cursor-pointer"
                          @click="() => onClickApprove(item)"
                          >Approve Item</div
                        >
                        <div
                          v-if="
                            item?.status?.name === 'New' &&
                            getPermissionSR('review')
                          "
                          class="p-1 px-3 action-item cursor-pointer"
                          @click="() => onClickReview(item)"
                          >Review Item</div
                        >
                        <div
                          class="p-1 px-3 action-item cursor-pointer"
                          @click="() => onClickDetail(item)"
                          >Detail Item</div
                        >
                        <div
                          class="p-1 px-3 action-item cursor-pointer"
                          @click="() => onEditItem(item, index)"
                          v-if="
                            !['Progress', 'Finish'].includes(
                              item?.status?.name
                            ) && getPermissionSR('update')
                          "
                          >Update Item</div
                        >
                        <!-- v-if="item?.status?.name !== 'Request'" -->
                        <div
                          v-if="
                            !['Progress', 'Finish'].includes(
                              item?.status?.name
                            ) && getPermissionSR('delete')
                          "
                          class="p-1 px-3 action-item cursor-pointer"
                          @click="() => onDeleteItem(item, index)"
                          >Delete Item</div
                        >
                        <div
                          v-if="item?.status?.name === 'Progress'"
                          class="p-1 px-3 action-item cursor-pointer"
                          @click="onClickActivity(item)"
                          >Progress Activity</div
                        >
                      </b-popover>
                    </td>
                    <td
                      class="sticky bg-white"
                      :class="{
                        'col-3': !$route.query?.finish,
                        'col-3-finish': $route.query?.finish,
                      }"
                    >
                      {{ item.name == 'Others' ? item.other_name : item.name }}
                    </td>
                    <td class="p-2">
                      <b-button
                        type="button"
                        variant="warning"
                        size="sm"
                        class="d-flex justify-content-between align-items-center text-nowrap"
                        @click=";(showModal = true), (selectedItem = item)"
                      >
                        <i class="fa fa-paperclip"></i
                        >{{ item.file?.length }} Attachment</b-button
                      >
                    </td>
                    <td class="text-nowrap">
                      {{ formatCurrency(item.cost_estimate) ?? '-' }}
                    </td>
                    <td
                      class=""
                      v-if="$route.query?.finish || headerForm?.cost_real"
                      :style="{ minWidth: '240px' }"
                    >
                      <template
                        v-if="headerForm?.cost_real && $route.query?.detail"
                      >
                        {{ formatCurrency(item.cost_real) ?? '-' }}
                      </template>
                      <div v-else>
                        <InputCurrency
                          v-model="item.cost_real"
                          @input="sumRealCost"
                        />
                      </div>
                    </td>
                    <td
                      class="p-2"
                      v-if="$route.query?.finish || headerForm?.cost_real"
                      style="min-width: 200px"
                    >
                      <div
                        class="px-3"
                        v-if="headerForm?.cost_real && $route.query?.detail"
                      >
                        {{
                          doneByOptions?.find((el) => el.value == item?.done_by)
                            ?.text ?? '-'
                        }}
                      </div>
                      <b-form-select
                        v-else
                        v-model="item.done_by"
                        :options="doneByOptions"
                        plain
                        required
                      ></b-form-select>
                    </td>
                    <td
                      class="text-nowrap"
                      v-if="$route.query?.detail || formId"
                    >
                      <b-badge
                        :variant="`${
                          item?.status?.name === 'New'
                            ? 'info'
                            : item?.status?.name === 'Review'
                            ? 'primary'
                            : item?.status?.name === 'Reject'
                            ? 'danger'
                            : item?.status?.name === 'Finish'
                            ? 'danger'
                            : 'success'
                        } d-block`"
                        >{{ item?.status?.name }}</b-badge
                      >
                    </td>
                    <td class="text-nowrap">{{ item.title }} </td>
                    <td class="text-nowrap">
                      {{ moment(item.start_at).format('DD MMM YYYY') }}
                    </td>
                    <td class="text-nowrap">
                      {{
                        moment(item.estimated_finished_at).format('DD MMM YYYY')
                      }}
                    </td>
                    <td class="text-nowrap">
                      {{ findText(optionsTaskType, item.task_type_id) }}
                    </td>
                    <td class="text-nowrap">
                      {{ item.section }}
                    </td>
                    <td class="text-nowrap">
                      {{ findText(optionsCategory, item.category_id) }}
                    </td>
                    <td class="text-nowrap">
                      {{
                        findText(optionsClassification, item.classification_id)
                      }}
                    </td>
                    <td class="text-nowrap">
                      {{ findText(optionsCause, item.case_id) }}
                    </td>
                    <td class="text-nowrap">
                      {{ findText(optionsKindTask, item.kind_task_id) }}
                    </td>
                    <td
                      class="pr-4"
                      style="
                        max-width: 400px;
                        white-space: nowrap;
                        overflow: hidden;
                      "
                    >
                      <p class="m-0 ellipsis" :id="`tooltip-remark-${item.id}`">
                        {{ item.description }}
                      </p>
                      <b-tooltip
                        class="custom-style-tooltip"
                        :target="`tooltip-remark-${item.id}`"
                        triggers="hover"
                        placement="top"
                      >
                        {{ item.description }}</b-tooltip
                      >
                    </td>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
          <div v-if="loading.fetch" class="d-flex justify-content-center py-5">
            <b-spinner size="lg"></b-spinner>
          </div>
        </div>
      </b-col>
      <b-col md="12" class="mt-4" v-if="$route.query?.detail && formId">
        <b-button type="button" variant="link" v-b-toggle.log-collapse>
          <h6><strong>Log History</strong></h6>
        </b-button>
        <b-collapse id="log-collapse">
          <LogsHistoryItemSR
            :defaultParams="defaultParams"
            :selectedItem="{ id: formId }"
          />
        </b-collapse>
      </b-col>

      <!-- ACTION CREATE SR || FINISH SET REALIZATION -->

      <template v-if="!$route.query.detail">
        <b-col class="d-flex justify-content-end mt-4">
          <b-button
            type="button"
            variant="outline-primary"
            class="mr-2"
            @click="$router.push('/sr/service-repair-list')"
            >Cancel</b-button
          >
          <b-button type="submit" v-if="!loading.post" variant="primary"
            >Submit</b-button
          >
          <b-button type="button" v-else variant="primary">
            <b-spinner small class="mr-2"></b-spinner> Loading...
          </b-button>
        </b-col>
      </template>
      <!-- ACTION UPDATE JOBS-->
      <template v-if="!$route.query.detail && formId && !$route.query.finish">
        <b-col class="d-flex justify-content-end mt-4">
          <b-button
            type="button"
            variant="outline-primary"
            class="mr-2"
            @click="$router.push('/sr/service-repair-list')"
            >Cancel</b-button
          >
          <template v-if="getPermissionSR('update')">
            <b-button
              type="button"
              v-if="!loading.post"
              @click="() => handleUpdateJobs(listItems)"
              variant="primary"
              >Submit</b-button
            >
            <b-button type="button" v-else variant="primary">
              <b-spinner small class="mr-2"></b-spinner> Loading...
            </b-button>
          </template>
        </b-col>
      </template>
    </b-row>
  </form>
</template>
<script>
import {
  crewingActions,
  fleetsActions,
  maintenanceActions,
  srActions,
} from '@/src/Utils/helper'
import FormItemSR from './FormItemSR.vue'
import moment from '@/node_modules/moment/moment'
import DetailItemSR from './DetailItemSR.vue'
import ModalAttacment from './ModalAttacment.vue'
import DailyProgress from './DailyProgress.vue'
import FormReviewSR from './FormReviewSR.vue'
import LogsApprovalSR from './LogsApprovalSR.vue'
import LogsHistoryItemSR from './LogsHistoryItemSR.vue'
import FormApproveSR from './FormApproveSR.vue'
import { getAccessPermission } from '@/src/plugins/helpers'
import InputCurrency from '@/src/components/global/InputCurrency.vue'

export default {
  name: 'ListItemSR',
  props: {
    headerForm: {
      type: Object,
      default: () => {},
    },
    headerFormErr: {
      type: Object,
      default: () => {},
    },
    fleetSelected: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    FormItemSR,
    DetailItemSR,
    ModalAttacment,
    DailyProgress,
    FormReviewSR,
    LogsApprovalSR,
    LogsHistoryItemSR,
    FormApproveSR,
    InputCurrency,
  },
  data() {
    return {
      multipleSelected: [],
      popoverIdx: null,
      listItems: [],
      isReview: false,
      checkedAll: false,
      checkedItems: [],
      filterByName: '',
      selectedItem: null,
      selectedIndex: null,
      showSidebar: false,
      showModal: false,
      titleSidebar: '',
      optionsTaskType: [],
      optionsDepartment: [],
      optionsCategory: [],
      optionsClassification: [],
      optionsCause: [],
      optionsKindTask: [],
      isExistFleet: false,
      formId: null,
      defaultParams: {
        user_id: JSON.parse(localStorage.getItem('profile')).id,
      },
      doneByOptions: [
        { text: 'Internal Man Power', value: 'internal_man_power' },
        { text: 'Sub Contractor', value: 'sub_contractor' },
      ],
      loading: {
        post: false,
        fetch: false,
        deleteBulk: false,
      },
    }
  },
  computed: {
    isChckedAll() {
      const filteredData = this.listItems?.filter(
        (el) => el?.status?.name == 'New'
      )
      if (filteredData?.length) {
        return filteredData?.every((el) => el.checked)
      } else {
        return false
      }
    },
    showReview() {
      const filteredData = this.listItems?.filter((el) => el?.checked)
      return filteredData.some((el) => el.status.name == 'New')
    },
    showApprove() {
      const filteredData = this.listItems?.filter((el) => el?.checked)
      return filteredData.some((el) => el.status.name == 'Review')
    },

    showDeleteBulk() {
      const filteredData = this.listItems?.filter(
        (el) => el.status.name !== 'Progress'
      )
      return filteredData.some((el) => el?.checked)
    },
    // disabledApprove:()=>{
    //   return this.listItems?.some((el)=> el?.status?.name == 'Review')
    // },
  },
  methods: {
    ...fleetsActions,
    ...srActions,
    ...crewingActions,
    ...maintenanceActions,
    isVisible(item) {
      const show =
        !this.filterByName ||
        item?.name?.toLowerCase().includes(this.filterByName?.toLowerCase()) ||
        item?.other_name?.toLowerCase().includes(this.filterByName?.toLowerCase())
      return show ? true : false
    },
    getPermissionSR(acces_type) {
      return getAccessPermission('Service Repair', acces_type)
    },
    handleRefetch() {
      this.showSidebar = false
      this.getSingleServiceAndRepair(this.formId)
    },
    async getMasterTaskType() {
      try {
        const { data } = await this.fetchMasterTaskType(this.defaultParams)
        const options = data.map((el) => ({
          text: el.name,
          value: el.id,
        }))
        this.optionsTaskType = [
          { value: null, text: '-- Select Type R & M --' },
          ...options,
        ]
      } catch (error) {
        console.log(error)
      }
    },
    async getMasterDepartment() {
      try {
        const { data } = await this.fetchListDepartment(this.defaultParams)
        const options = data.data.map((el) => ({
          text: el.name,
          value: el.id,
          alias: el.alias,
        }))
        this.optionsDepartment = [
          { value: null, text: '-- Select Department --' },
          ...options,
        ]
      } catch (error) {
        console.log(error)
      }
    },
    async getMasterCategory() {
      try {
        const { data } = await this.fetchMasterCategory(this.defaultParams)
        const options = data.map((val) => ({
          text: val.name,
          value: val.id,
        }))
        this.optionsCategory = [
          { value: null, text: '-- Select Category --' },
          ...options,
        ]
      } catch (error) {
        console.log(error)
      }
    },
    async getMasterClassification() {
      try {
        const { data } = await this.fetchMasterClassification(
          this.defaultParams
        )
        const options = data.map((val) => ({
          text: `${val.name} (${val.interval} ${val.unit})`,
          value: val.id,
          interval: val.interval,
        }))
        this.optionsClassification = [
          { value: null, text: '-- Select Classification --' },
          ...options,
        ]
      } catch (error) {
        console.log(error)
      }
    },
    async getMasterCause() {
      try {
        const { data } = await this.fetchMasterCause(this.defaultParams)
        const options = data.map((val) => ({
          text: val.name,
          value: val.id,
        }))
        this.optionsCause = [
          { value: null, text: '-- Select Cuase --' },
          ...options,
        ]
      } catch (error) {
        console.log(error)
      }
    },
    async getMasterKindTask() {
      try {
        const { data } = await this.fetchMasterKindTask(this.defaultParams)
        const options = data.map((val) => ({
          text: val.name,
          value: val.id,
        }))
        this.optionsKindTask = [
          { value: null, text: '-- Select Kind Of Task --' },
          ...options,
        ]
      } catch (error) {
        console.log(error)
      }
    },
    async onSetCloseSR() {
      try {
        this.loading.post = true
        const formData = new FormData()
        formData.append(
          'start_date_real',
          moment(this.headerForm.start_date_real).format('YYYY-MM-DD')
        )
        formData.append(
          'finish_date_real',
          moment(this.headerForm.finish_date_real).format('YYYY-MM-DD')
        )
        formData.append('cost_real', this.headerForm.cost_real)
        formData.append('remark_finish', this.headerForm.remark_finish)
        const newFiles = Array.from(this.headerForm.files)
        if (newFiles.length) {
          newFiles.forEach((file, index) => {
            if (file instanceof File) {
              formData.append('files[]', file)
            }
          })
        }

        if (this.headerForm.deleted_files?.length) {
          formData.append(
            'deleted_files',
            JSON.stringify(this.headerForm.deleted_files)
          )
        }
        this.listItems.forEach((item, i) => {
          formData.append(`contents[${i}][id]`, item.id)
          formData.append(`contents[${i}][cost_real]`, item.cost_real)
          formData.append(`contents[${i}][done_by]`, item.done_by)
        })

        for (let [key, value] of formData.entries()) {
          console.log(key, value)
        }

        const res = await this.setCloseService({
          id: this.formId,
          data: formData,
          params: this.defaultParams,
        })
        this.$swal(
          `Success!`,
          `Success Set Finish Service Reapair!!`,
          'success'
        )
        this.$router.push('/sr/service-repair-list')
      } catch (error) {
        this.$swal(`Oops!`, `Failed Set Close Data!!`, 'error')
      }
      this.loading.post = false
    },
    handleEditMulti() {
      const filtered = this.listItems.filter((el) => el.checked)
      if (filtered?.length) {
        this.titleSidebar = 'Update Service & Repair'
        this.selectedItem = null
        this.multipleSelected = filtered.map((el) => ({
          ...el,
          maintenance_master_id:
            el.name == 'Others' ? 'other' : el.maintenance_master_id,
        }))
        this.showSidebar = true
      } else {
        this.$swal(
          'Gagal!',
          'Silahkan centang item terlebih dahulu!',
          'warning'
        )
      }
    },
    handleSubmit() {
      if (this.$route.query.finish) {
        this.onSetCloseSR()
      } else {
        if (!this.headerForm?.accident_at) {
          this.headerFormErr.accident_at = true
        } else {
          this.headerFormErr.accident_at = false
          this.handleCreateServiceAndRepair()
        }
      }
    },
    handleSaveItem(items) {
      const cloneItmes = items.map((item) => ({
        ...item,
      }))
      if (this.selectedItem) {
        this.$set(this.listItems, this.selectedIndex, { ...items[0] })
      } else {
        this.listItems = [...this.listItems, ...cloneItmes]
      }
      this.showSidebar = false
    },
    onEditItem(item, index) {
      this.selectedItem = item
      this.selectedIndex = index
      this.showSidebar = true
      this.titleSidebar = 'Update Service & Repair'
      this.multipleSelected = []
    },
    onDeleteItem(item, index) {
      console.log(item)
      item?.id
        ? this.onDeleteRepair(item)
        : (this.listItems = this.listItems.filter((_, i) => i !== index))
    },
    onClickAdd() {
      this.showSidebar = true
      this.selectedItem = null
      this.multipleSelected = []
      this.titleSidebar = 'Add Service & Repair'
    },
    onClickDetail(item) {
      this.showSidebar = true
      this.selectedItem = item
      this.titleSidebar = 'Detail Item Service & Repair'
    },
    onClickActivity(item) {
      this.showSidebar = true
      this.selectedItem = item
      this.titleSidebar = 'Progress Item Repair'
    },
    findText(options, id) {
      return options.find((el) => el?.value == id)?.text
    },
    handleCheckAll() {
      if (this.checkedAll) {
        this.listItems = this.listItems.map((el) =>
          // el?.status?.name == 'New' ? { ...el, checked: true } : el
          ({ ...el, checked: true })
        )
      } else {
        this.listItems = this.listItems.map((el) => ({ ...el, checked: false }))
      }
    },
    updateCheckAll() {
      this.checkedAll = this.checkedItems.length === this.listItems.length
    },
    getFilenameFromPath(path) {
      return path.split('/').pop()
    },
    async getSingleServiceAndRepair(id, limited = 0) {
      this.loading.fetch = true
      try {
        if (id) {
          let limit = 9999
          limit += limited
          let params = {
            limit: limit,
            ...this.defaultParams,
          }
          let res = await this.fetchSingleServiceAndRepair({ id, params })
          // SET FORM HEADER SERVICE REPAIR
          for (const key in res.data) {
            for (const key2 in this.headerForm) {
              if (key2 == 'filePreview')
                this.headerForm[key2] = res.data.files?.map((el) => ({
                  id: 1,
                  name: this.getFilenameFromPath(el.path),
                  ...el,
                }))
              if (key2 == key) {
                if (
                  [
                    'accident_at',
                    'finish_date_est',
                    'start_date_est',
                    'finish_date_real',
                    'start_date_real',
                  ].includes(key2)
                ) {
                  this.headerForm[key2] = res.data[key]
                    ? moment(res.data[key]).toDate()
                    : null
                } else {
                  this.headerForm[key2] = res.data[key]
                }
              }
            }
          }
          this.listItems = res.data.form_repair.map((el) => ({
            ...el,
            checked: false,
            start_at: moment(el.start_at).toDate(),
            estimated_finished_at: moment(el.estimated_finished_at).toDate(),
            subcons: el.entity?.length
              ? el.entity
                  .filter((ent) => ent.entity_type == 'sub_kontraktor')
                  ?.map((subcon) => ({
                    ...subcon,
                    filePreview: this.setIdFile(subcon.subkon_file),
                  }))
              : [],
            internal_manpower: el.entity?.length
              ? el.entity.filter((ent) => ent.entity_type == 'internal')
              : [],
            filePreview: el.file,
            cost_real: el?.cost_real ?? null,
          }))
          if (this.$route.query?.finish) {
            this.setMinMaxDate()
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading.fetch = false
      }
    },
    setIdFile(arrString) {
      const arrFile = JSON.parse(arrString)
      if (Array.isArray(arrFile)) {
        return arrFile.map((el) => ({
          ...el,
          id: 1,
          name: this.getFilenameFromPath(el.path),
        }))
      }
    },
    async onCheckVehicleExist() {
      try {
        const { data } = await this.checkVehicleExist({
          id: this.$route.query?.vehicleId,
          params: this.defaultParams,
        })
        if (data.data.vehicle_exist) {
          this.isExistFleet = true
          this.formId = data.data.form_id
          this.$emit('existFleet', this.formId)
          await this.getSingleServiceAndRepair(data.data.form_id)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async onDeleteRepair(repairData) {
      this.$swal({
        title: `Are you sure want to delete ${repairData?.name} Repair Job?`,
        text: "Yes, i'm sure.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const res = await this.deleteRepair({
            id: repairData.id,
            params: this.defaultParams,
          })
          if (
            res.status === false ||
            res.status === 400 ||
            res.status === 500
          ) {
            this.$swal('Failed!', 'Something went wrong.', 'error')
            return
          }
          this.$swal('Success!', 'Success delete r&m.', 'success')
          this.handleRefetch()
        }
      })
    },
    async handleCreateServiceAndRepair() {
      try {
        if (this.listItems.length) {
          this.loading.post = true
          let formData = new FormData()
          formData.append(
            'accident_at',
            moment(this.headerForm.accident_at).format('YYYY-MM-DD')
          )
          formData.append('vehicle_id', this.headerForm.vehicle_id)
          formData.append('pic_id', this.headerForm.pic_id)
          formData.append('created_by', this.headerForm.created_by)
          formData.append('location', this.headerForm.location)
          formData.append('pic', this.headerForm.pic)
          formData.append('site', this.headerForm.site)
          formData.append('type_of_job', this.headerForm.type_of_job)
          formData.append('updated_by', this.headerForm.updated_by)
          formData.append('user_id', this.headerForm.user_id)
          formData.append('user_name', this.headerForm.user_name)
          formData.append('cost_est', this.headerForm.cost_est)
          formData.append('remark', this.headerForm.remark)
          formData.append(
            'start_date_est',
            moment(this.headerForm.start_date_est).format('YYYY-MM-DD')
          )
          formData.append(
            'finish_date_est',
            moment(this.headerForm.finish_date_est).format('YYYY-MM-DD')
          )

          const newFiles = Array.from(this.headerForm.files)
          if (newFiles.length) {
            newFiles.forEach((file, index) => {
              if (file instanceof File) {
                formData.append('files[]', file)
              }
            })
          }
          this.listItems.forEach((item, index) => {
            if (item.maintenance_master_id == 'other') {
              delete item.maintenance_master_id
            }
            item.file.forEach((file, fileIndex) => {
              formData.append(`file[${index}]`, file)
            })
            for (const property in item) {
              if (
                property == 'start_at' ||
                property == 'estimated_finished_at'
              ) {
                formData.append(
                  `contents[${index}][${property}]`,
                  moment(item[property]).format('YYYY-MM-DD')
                )
              } else {
                formData.append(
                  `contents[${index}][${property}]`,
                  item[property]
                )
              }
            }
            formData.append(`contents[${index}][cost_real]`, 0)
          })
          const params = { user_id: this.headerForm.user_id }
          const res = await this.createServiceAndRepair({
            data: formData,
            params,
          })
          await this.getSingleServiceAndRepair(this.formId)
          this.$swal(
            `Berhasil!`,
            `Create Service & Repair Berhasil.`,
            'success'
          )
          this.$router.push('/sr/service-repair-list')
        } else {
          this.$swal(`Oops!`, `Item Service Repair Can't null!`, 'error')
        }
      } catch (error) {
        console.log(error)
        this.$swal(`Oops!`, `Failed Create Data!!`, 'error')
      }
      this.loading.post = false
    },
    onClickReview(item) {
      this.showSidebar = true
      this.isReview = true
      this.multipleSelected = [item]
      this.titleSidebar = 'Review Item Service & Repair'
    },
    onReviewBulk() {
      this.multipleSelected = this.listItems.filter(
        (el) => el.checked && el?.status?.name == 'New'
      )
      if (this.multipleSelected.length) {
        this.showSidebar = true
        this.isReview = true
        this.titleSidebar = 'Review Item Service & Repair'
      } else {
        this.$swal(
          'Review Gagal!',
          'Silahkan tambah pekerjaan terlebih dahulu!',
          'warning'
        )
      }
    },
    onClickApprove(item) {
      this.showSidebar = true
      this.multipleSelected = [
        {
          ...item,
          isApprove: false,
        },
      ]
      this.titleSidebar = 'Approve Item Service & Repair'
    },
    onApproveBulk() {
      this.showSidebar = true
      this.multipleSelected = this.listItems
        .filter((el) => el.status.name == 'Review' && el.checked)
        .map((el) => ({
          ...el,
          isApprove: false,
        }))
      this.titleSidebar = 'Approve Item Service & Repair'
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(value)
    },
    sumRealCost(items) {
      this.headerForm.cost_real = this.listItems.reduce(
        (total, item) => total + Number(item.cost_real),
        0
      )
    },
    deleteItemBeforeCreate() {
      const checkedData = this.listItems.filter((el) => el.checked)
      if (!checkedData.length) {
        this.$swal(
          'Gagal!',
          'Silahkan centang item terlebih dahulu!',
          'warning'
        )
        return
      }
      this.listItems = this.listItems?.filter((el) => !el.checked)
    },
    async handleDeleteJobs() {
      try {
        this.loading.deleteBulk = true
        const checkedData = this.listItems.filter((el) => el.checked)
        if (!checkedData.length) {
          this.$swal(
            'Gagal!',
            'Silahkan centang item terlebih dahulu!',
            'warning'
          )
          return
        }
        this.$swal({
          title: `Are you sure want to delete bulk repair item?`,
          text: "Yes, i'm sure.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        }).then(async (result) => {
          if (result.isConfirmed) {
            // const checkedData = this.listItems.filter((el) => el.checked)
            const ids = checkedData.map((el) => el.id)
            const params = this.defaultParams
            const res = await this.deleteJobsBulk({
              data: { form_repair_ids: ids },
              params,
            })
            this.$swal('Success!', 'Success delete r&m.', 'success')
            this.handleRefetch()
          }
        })
      } catch (error) {
        this.$swal('Failed!', 'Failed delete items', 'error')
        console.log(error)
      }
      this.loading.deleteBulk = false
    },
    async handleUpdateJobs(formRepairs, from) {
      try {
        this.loading.post = true
        let formData = new FormData()
        formData.append(
          'accident_at',
          moment(this.headerForm.accident_at).format('YYYY-MM-DD')
        )
        formData.append('id', this.formId)
        formData.append('vehicle_id', this.headerForm.vehicle_id)
        formData.append('created_by', this.headerForm.created_by)
        formData.append('location', this.headerForm.location)
        formData.append('pic', this.headerForm.pic)
        formData.append('site', this.headerForm.site)
        formData.append('type_of_job', this.headerForm.type_of_job)
        formData.append('updated_by', this.headerForm.updated_by)
        formData.append('user_id', this.headerForm.user_id)
        formData.append('user_name', this.headerForm.user_name)
        formData.append('cost_est', this.headerForm.cost_est)
        formData.append('remark', this.headerForm.remark)
        formData.append(
          'start_date_est',
          moment(this.headerForm.start_date_est).format('YYYY-MM-DD')
        )
        formData.append(
          'finish_date_est',
          moment(this.headerForm.finish_date_est).format('YYYY-MM-DD')
        )

        if (this.headerForm.files?.length) {
          const newFiles = Array.from(this.headerForm.files)
          newFiles.forEach((file, index) => {
            if (file instanceof File) {
              formData.append('files[]', file)
            }
          })
        }

        const excepColumns = [
          'status',
          'classification',
          'category',
          'task_type',
          'case',
          'kind_task',
          'department',
          'filePreview',
        ]

        formRepairs.forEach((item, index) => {
          if (item.maintenance_master_id == 'other') {
            item.maintenance_master_id = null
          }
          item.file.forEach((file, fileIndex) => {
            formData.append(`file[${index}]`, file)
          })
          for (const property in item) {
            if (!excepColumns.includes(property)) {
              if (
                property == 'start_at' ||
                property == 'estimated_finished_at'
              ) {
                formData.append(
                  `contents[${index}][${property}]`,
                  moment(item[property]).format('YYYY-MM-DD')
                )
              } else {
                formData.append(
                  `contents[${index}][${property}]`,
                  item[property]
                )
              }
            }
          }
          formData.append(`contents[${index}][cost_real]`, 0)
        })
        const res = await this.updateServiceAndRepair({
          data: formData,
          params: {
            user_id: this.headerForm.user_id,
          },
        })
        this.$swal(`Berhasil!`, `Update Service & Repair Berhasil.`, 'success')
        this.handleRefetch()
        if (!from) {
          this.$router.push('/sr/service-repair-list')
        }
      } catch (error) {
        console.log(error)
        this.$swal(`Oops!`, `Failed Update Data!!`, 'error')
      }
      this.loading.post = false
    },
    setMinMaxDate() {
      const latest = this.listItems.reduce((max, item) => {
        return new Date(item.actual_finished_at) >
          new Date(max.actual_finished_at)
          ? item
          : max
      })
      const earliest = this.listItems.reduce((min, item) => {
        return new Date(item.actual_started_at) <
          new Date(min.actual_started_at)
          ? item
          : min
      })
      this.headerForm.start_date_real = moment(
        earliest?.actual_started_at
      ).toDate()
      this.headerForm.finish_date_real = moment(
        latest?.actual_finished_at
      ).toDate()
      console.log(latest.actual_started_at, earliest.actual_finished_at)
    },
  },
  watch: {
    listItems: {
      handler(newValue, oldValue) {
        this.headerForm.cost_est = newValue.reduce(
          (total, item) => total + Number(item.cost_estimate),
          0
        )
      },
      deep: true,
    },
  },
  async mounted() {
    await this.getMasterTaskType()
    await this.getMasterDepartment()
    await this.getMasterCategory()
    await this.getMasterClassification()
    await this.getMasterCause()
    await this.getMasterKindTask()
    if (this.$route.query?.formId) {
      this.isExistFleet = true
      this.formId = this.$route.query?.formId
      this.$emit('existFleet', this.formId)
      await this.getSingleServiceAndRepair(this.formId)
    } else {
      if (this.$route.query?.vehicleId) {
        await this.onCheckVehicleExist()
      }
    }
    if (this.$route.query?.review) {
      this.listItems = this.listItems.map((el) =>
        el.status?.name == 'New' ? { ...el, checked: true } : el
      )
      this.onReviewBulk()
    }
    if (this.$route.query?.approve) {
      this.listItems = this.listItems.map((el) =>
        el.status?.name == 'Review' ? { ...el, checked: true } : el
      )
      this.onApproveBulk()
    }
  },
}
</script>
<style scoped>
table td {
  border-bottom: 1px gray solid !important;
  color: black;
  padding: 8px 24px;
}

table th {
  padding: 8px 24px;
}

.overflow-auto {
  overflow: auto !important;
  min-height: 200px;
}

.sticky {
  position: sticky !important;
  z-index: 999 !important;
}

.relative {
  position: relative !important;
}

.col-1 {
  left: 0px !important;
  /* z-index: 2; */
  min-width: 40px;
  max-width: 40px;
}

.col-2 {
  left: 40px !important;
  /* z-index: 2; */
  min-width: 100px;
  max-width: 100px;
}

.col-2-finish {
  left: 0px !important;
  /* z-index: 2; */
  min-width: 140px;
  max-width: 140px;
}

.col-3 {
  left: 140px !important;
  /* z-index: 2; */
  min-width: 300px;
  max-width: 300px;
}

.col-3-finish {
  left: 140px !important;
  /* z-index: 2; */
  min-width: 300px;
  max-width: 300px;
}

.action-item {
  font-weight: 400;
}

.action-item:hover {
  background: #eceeed;
}

.custom-style-tooltip {
  white-space: normal;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
